.buttonContainer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-right: 10px;
}